import keyMirror from 'helpers/keymirror';

enum PositionAnalyseActionTypes {
  SET_POSITIONS = 'SET_POSITIONS',
  POSITION_ANALYTICS = 'POSITION_ANALYTICS ',
  POSITION_ANALYSE_LOADING = 'POSITION_ANALYSE_LOADING',
  POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_PRICE = 'POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_PRICE',
  POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_DATE = 'POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_DATE',
  POSITION_ANALYZE_PNL_TABLE_TAB_SELECTED_ROWS = 'POSITION_ANALYZE_PNL_TABLE_TAB_SELECTED_ROWS',
  UPDATE_MODAL_STATE = 'UPDATE_MODAL_STATE',
  ADD_PRODUCT_TO_ANALYZE = 'ADD_PRODUCT_TO_ANALYZE',
  REMOVE_ALL_PRODUCT_FROM_ANALYZE = 'REMOVE_ALL_PRODUCT_FROM_ANALYZE',
  POSITION_ANALYTICS_PNL_TAB_LAST_RESOLVED_TARGET_PRICE = 'POSITION_ANALYTICS_PNL_TAB_LAST_RESOLVED_TARGET_PRICE',
  POSITION_ANALYTICS_INITIALLY_SELECTED_POSITION_IDS = 'POSITION_ANALYTICS_INITIALLY_SELECTED_POSITION_IDS',
  RESET_POSITION_ANALYTICS = 'RESET_POSITION_ANALYTICS',
}

const ActionTypes = {
  [PositionAnalyseActionTypes.POSITION_ANALYTICS]: null,
};

const POSITION_ANALYSE_ACTION_TYPES = keyMirror(ActionTypes);

export { PositionAnalyseActionTypes };
export default POSITION_ANALYSE_ACTION_TYPES;
